export const DEFAULT_KEY_FALLBACKS = {
 KeyZ: (lc) => lc?.backwardSlowDownKey ?? "Z",
 Slash: (lc) => lc?.forwardSpeedUpKey ?? "/",
 KeyS: (lc) => lc?.KeyS ?? "S",
 KeyD: (lc) => lc?.KeyD ?? "D",
 KeyF: (lc) => lc?.KeyF ?? "F",
 KeyK: (lc) => lc?.KeyK ?? "K",
 KeyL: (lc) => lc?.KeyL ?? "L",
 Semicolon: (lc) => lc?.Semicolon ?? ";",
 Space: () => "Space",
 spaceKey: (lc) => lc?.spaceKey ?? "Space",
};

export function escapeHtml(value) {
 return String(value)
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#39;");
}

export function normalizeLineBreaks(text) {
 return String(text ?? "")
  .replace(/\\n/g, "\n")
  .replace(/\/n/g, "\n");
}

export function numberOr(value, fallback) {
 return Number.isFinite(value) ? value : fallback;
}

export function resolveKeyForLayout(keyCode, layoutConfig, fallbacks = DEFAULT_KEY_FALLBACKS) {
 const fn = fallbacks[keyCode];
 return fn ? fn(layoutConfig) : keyCode;
}

function getHighlightSourceText(highlight) {
 if (highlight?.conditional?.key) return `{{${highlight.conditional.key}}}`;
 if (highlight?.conditional?.text) return String(highlight.conditional.text);
 if (highlight?.text) return String(highlight.text);
 return "";
}

function getHighlightDisplayText(highlight, layoutConfig, fallbacks) {
 if (highlight?.conditional?.key) {
  return resolveKeyForLayout(highlight.conditional.key, layoutConfig, fallbacks);
 }
 if (highlight?.conditional?.text) return String(highlight.conditional.text);
 if (highlight?.text) return String(highlight.text);
 return "";
}

export function renderTextWithHighlights(
 rawText,
 highlights,
 layoutConfig,
 options = {}
) {
 const { highlightColor = "#DE5700", keyFallbacks = DEFAULT_KEY_FALLBACKS } = options;
 let text = escapeHtml(normalizeLineBreaks(rawText));

 if (Array.isArray(highlights) && highlights.length > 0) {
  const sorted = [...highlights]
   .filter((hl) => getHighlightSourceText(hl))
   .sort((a, b) => getHighlightSourceText(b).length - getHighlightSourceText(a).length);

  sorted.forEach((hl) => {
   const sourceText = getHighlightSourceText(hl);
   const displayText = getHighlightDisplayText(hl, layoutConfig, keyFallbacks);
   if (!sourceText || !displayText) return;
   const escaped = sourceText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
   text = text.replace(
    new RegExp(escaped, "g"),
    `<span style="color:${highlightColor};font-weight:700;">${escapeHtml(displayText)}</span>`
   );
  });
 }

 text = text.replace(
  /\{\{([A-Za-z0-9_]+)\}\}/g,
  (_, key) => escapeHtml(resolveKeyForLayout(key, layoutConfig, keyFallbacks))
 );

 return text.replace(/\n/g, "<br />");
}

function getHQPanelHost() {
 const footerAgent = document.getElementById("footerAgent");
 const footer = document.getElementById("footer");
 return footer || footerAgent;
}

export function mountHQPanel({ panelId, html, verticalOffsetPx = -6 }) {
 const host = getHQPanelHost();
 if (!host) return null;

 const existing = document.getElementById(panelId);
 if (existing) existing.remove();

 const wrapper = document.createElement("div");
 wrapper.id = panelId;
 wrapper.className = "gear-hq-panel-wrapper";
 wrapper.style.setProperty("--hq-panel-offset-y", `-${verticalOffsetPx}px`);
 wrapper.innerHTML = html;

 host.appendChild(wrapper);
 return wrapper;
}

export function removeHQPanel(panelId) {
 const panel = document.getElementById(panelId);
 if (panel) panel.remove();
}